import adk from 'service/adk'
import dponet from 'service/modules/dponet'
import { getDaiDisputesBaseUrl } from 'service/env'

const getAuthToken = () => dponet.auth.getToken()

const { api } = adk.create(getDaiDisputesBaseUrl(), getAuthToken)

// Evidências escopadas por activity: company vem do token (auth), project e activity
// vão no path. Path no agente: /api/v1/evidences/{project}/{activity}/...
const uploadEvidence = async ({
  governanceProjectId,
  governanceProjectActivityId,
  file,
}) =>
  await api.postForm(
    `/api/v1/evidences/${governanceProjectId}/${governanceProjectActivityId}/upload`,
    { files: file },
  )

const listEvidences = async ({
  governanceProjectId,
  governanceProjectActivityId,
}) =>
  await api.get(
    `/api/v1/evidences/${governanceProjectId}/${governanceProjectActivityId}`,
  )

const reconcileEvidences = async ({
  governanceProjectId,
  governanceProjectActivityId,
  keepFilenames,
}) =>
  await api.post(
    `/api/v1/evidences/${governanceProjectId}/${governanceProjectActivityId}/reconcile`,
    { keep_filenames: keepFilenames },
  )

const create = async ({
  questionCode,
  governanceProjectId,
  governanceProjectActivityId,
  auditorReport,
}) =>
  await api.post('/api/v1/disputes', {
    question_code: questionCode,
    governance_project_id: governanceProjectId,
    governance_project_activity_id: governanceProjectActivityId,
    auditor_report: auditorReport,
  })

const getStatus = async (runId) => await api.get(`/api/v1/disputes/${runId}`)

const getDocument = async (runId) =>
  await api.get(`/api/v1/disputes/${runId}/document`)

export default {
  create,
  getDocument,
  getStatus,
  listEvidences,
  reconcileEvidences,
  uploadEvidence,
}
